<template>

  <v-app
    id="tavolos-widget"
    v-if="restaurant_status === true"
    v-bind:class="{ 'has-publisher' : publisher_id !== 0 }"
  >
    <!-- Message -->
    <v-layout row wrap>
      <v-snackbar
          :top="'top'"
          :timeout="snackbarTimeout"
          :color="snackbarColor"
          :multi-line="snackbarMode === 'multi-line'"
          :vertical="snackbarMode === 'vertical'"
          v-model="snackbar"
        >
        {{ snackbarMessages }}
        <v-btn class="tavolos-btn" color="dark" flat @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-layout>

    <!-- Header -->
    <v-layout row wrap>
      <v-flex xs12>
        <div class="tavolos-header">

          <h1 class="tavolos-title" v-if="tabsIndex !== 3">Book a table at <span v-for="restaurant in getResource.restaurants">{{ restaurant.restaurant }}</span></h1>
          <h1 class="tavolos-title" v-if="tabsIndex === 3">Success</h1>
          <transition name="tavolos-slide-right-fade" mode="out-in">
            <div v-if="((reservationModel.people !== '') && (reservationModel.date && reservationModel.time !== null)) && tabsIndex !== 3">
              <div class="tavolos-summary">
                <span>Showing availability for <strong>{{ reservationModel.people }} people</strong></span><span v-for="restaurant in getResource.restaurants"> at <strong>{{ restaurant.restaurant }}</strong></span><span> on <strong>{{ reservationModel.date }}</strong> around <strong>{{ reservationModel.time }}</strong>.</span> <span v-if="tabsIndex <= 2"><a href="#tavolos-widget" class="tavolos-edit-link" @click="editReservation()">Edit reservation</a></span>
              </div>
            </div>
            <div v-if="((reservationModel.people !== '') && (reservationModel.date && reservationModel.time !== null)) && tabsIndex === 3">
              <div class="tavolos-summary">
                <span>Table reserved for <strong>{{ reservationModel.people }} people</strong></span><span v-for="restaurant in getResource.restaurants"> at <strong>{{ restaurant.restaurant }}</strong></span><span> on <strong>{{ reservationModel.date }}</strong> around <strong>{{ reservationModel.time }}</strong>.</span></span>
              </div>
            </div>
          </transition>
        </div>

      </v-flex>
    </v-layout>

    <transition name="tavolos-slide-right-fade" mode="out-in">
      <!-- Tabs 1 -->
      <v-layout row wrap
        v-if="tabsIndex === 1" key="1"
      >
        <v-form v-model="valid" ref="formReservation" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12 sm6 >
              <v-menu
                lazy
                :close-on-content-click="true"
                v-model="menuPeople"
                transition="slide-y-transition"
                full-width
                content-class="tavolos-block-people"
              >
                <v-text-field
                  slot="activator"
                  label="Number of seats"
                  v-model="reservationModel.people"
                  prepend-icon="local_dining"
                  readonly
                  ref="people"
                  :rules="[v => !!reservationModel.people || 'Please select people']"
                  required

                  onclick="ga('tavolos.send', 'event', 'widget_interaction', 'view_options', 'seats')"

                ></v-text-field>

              <v-list>
                <v-list-tile
                  v-for="option in getCoverOptions()"
                  :key="option"
                  @click="reservationModel.people = option"
                  onclick="ga('send', 'event', 'widget_interaction', 'select_option', 'number_of_seats', text)"
                >
                  <v-list-tile-title>{{ option }}</v-list-tile-title>
                </v-list-tile>
              </v-list>

              </v-menu>

            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                lazy
                :close-on-content-click="true"
                v-model="menuDate"
                transition="slide-y-transition"
                full-width
                content-class="tavolos-block-date"
                :nudge-right="36"
                max-width="290px"
                min-width="290px"

                onclick="ga('tavolos.send', 'event', 'widget_interaction', 'view_options', 'select_date')"
              >
                <v-text-field
                  slot="activator"
                  label="Select date"
                  v-model="reservationModel.date"
                  prepend-icon="event"
                  readonly
                  ref="date"
                  :rules="[v => !!reservationModel.date || 'Please select date']"
                  required
                ></v-text-field>
                <v-date-picker
                  v-model="reservationModel.date"
                  :allowed-dates="availabilityDate"
                  no-title
                  actions
                >
                  <template slot-scope="{ save, cancel }">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="tavolos-btn" flat @click="cancel">Cancel</v-btn>
                      <v-btn class="tavolos-btn" flat @click="save">OK</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap>

            <v-flex xs12 sm6>

              <v-menu
                lazy
                :close-on-content-click="true"
                v-model="menuTime"
                transition="slide-y-transition"
                full-width
                content-class="tavolos-block-time"
              >
                <v-text-field
                  slot="activator"
                  label="Select time"
                  v-model="reservationModel.time"
                  prepend-icon="schedule"
                  readonly
                  ref="time"
                  :rules="[v => !!reservationModel.time || 'Please select time']"
                  required

                  onclick="ga('tavolos.send', 'event', 'widget_interaction', 'view_options', 'select_time')"

                ></v-text-field>

                  <v-list>
                    <v-list-tile
                      v-for="text in getTimeSlot(reservationModel.date, reservationModel.people)"
                      :key="text"
                      @click="reservationModel.time = text"
                      onclick="ga('send', 'event', 'widget_interaction', 'select_option', 'time_selected', text)"
                    >
                      <v-list-tile-title>{{ text }}</v-list-tile-title>
                    </v-list-tile>
                    <div class="no-data-text" v-if="isEmpty(getTimeSlot(reservationModel.date, reservationModel.people))" >
                      <span>Please select both the date and number of covers you’d like to book for.</span>
                    </div>
                  </v-list>

              </v-menu>
            </v-flex>
            <v-flex xs12 sm6>

              <v-btn
                @click="checkAvailability(reservationModel.date, reservationModel.time, reservationModel.people)"
                :disabled="!valid"
                id="checkAvailability"
                block
                color="primary"

                onclick="ga('send', 'event', 'widget_interaction', 'engagement', 'check_availability')"
              >
                Continue
              </v-btn>

            </v-flex>
          </v-layout>
        </v-form>
      </v-layout>

      <!-- Tabs 2 -->
      <v-layout
        row
        v-if="tabsIndex === 2" key="2"
      >
        <v-flex xs12>
        <v-form v-model="valid" ref="formReservationInfo" lazy-validation>
          <v-text-field
            name=""
            label="Reservation name"
            id=""
            v-model="reservationModel.name"
            :rules="[v => !!reservationModel.name || 'Reservation name is required']"
            required
            prepend-icon="title"
          ></v-text-field>
          <v-text-field
            name=""
            label="Email address"
            id=""
            :rules="emailRules"
            v-model="reservationModel.email"
            required
            prepend-icon="email"
          ></v-text-field>
          <v-text-field
            name=""
            label="Phone number"
            id=""
            v-model="reservationModel.phoneNumber"
            :rules="[v => !!reservationModel.phoneNumber || 'Phone number is required']"
            required
            prepend-icon="phone"
          ></v-text-field>
          <v-text-field
            name=""
            label="Do you have any special requests or allergies?"
            id=""
            counter="255"
            :maxlength="255"
            v-model="reservationModel.specialRequests"
            multi-line
            prepend-icon="comment"
          ></v-text-field>

          <v-btn
            block
            color="primary"
            :loading="loadingReservation"
            :disabled="loadingReservation"
            @click="doReservation()"

            onclick="ga('tavolos.send', 'event', 'widget_interaction', 'engagement', 'reserve')"

          >
            Reserve!
            <span slot="loader" class="custom-loader">
              <v-icon light>cached</v-icon>
            </span>
          </v-btn>
        </v-form>
        </v-flex>
      </v-layout>

      <!-- Tabs 3 -->
      <v-layout
        row
        wrap
        v-if="tabsIndex === 3" key="3"
      >
        <v-flex>
          <p>A confirmation email has been sent to <span><strong>{{ reservationModel.email }}.</strong></span>
          <span class="tavolos-edit-email">
            <a class="tavolos-edit-link" href="#tavolos-widget" @click="goTabs(4)">Edit email</a> / <a href="#tavolos-widget" class="tavolos-edit-link" @click="updateDrupalEntity()" onclick="ga('tavolos.send', 'event', 'widget_interaction', 'engagement', 'resend_email')">Resend email</a>
          </span>
          </p>
          <div v-for="restaurant in getResource.restaurants">
            <p v-if="restaurant.tableHoldTime !== '0'">
              Please note that this reservation will be held for <strong>{{ restaurant.tableHoldTime }} minutes</strong> before it is offered to other diners.
            </p>
          </div>
          <p>Instructions on how do cancel are provided in your reservation confirmation email.</p>
          <p>Enjoy - Tavolos!</p>

        </v-flex>
      </v-layout>

      <!-- Tabs 4 -->
      <v-layout
        row
        wrap
        v-if="tabsIndex === 4" key="4"
      >
        <v-flex>
          <p><strong>Send confirmation email to:</strong></p>

          <v-text-field
            name=""
            label="Email address"
            id=""
            :rules="emailRules"
            v-model="reservationModel.email"
            required
            prepend-icon="email"
          ></v-text-field>

          <v-btn class="tavolos-btn" color="primary" block @click="changeEmail()" onclick="ga('tavolos.send', 'event', 'widget_interaction', 'engagement', 'change_email')">Change & Resend</v-btn>
        </v-flex>
      </v-layout>

    </transition>

    <!-- Footer -->
    <v-layout id="tavolos-about" row wrap>

      <a @click="toggleLogo =! toggleLogo" href="#tavolos" id="tavolos-logo">
        <img src="https://widget.tavolos.com/src/assets/images/logo.svg" alt="Tavolos.com!" >
      </a>
      <transition name="tavolos-slide-top-fade" mode="out-in">
      <div v-if="toggleLogo !== true" id="tavolos-content" transition="slide-y-transition">
        <p>Tavolos is the World’s free restaurant booking engine. Why pay for customers when you don’t need to? With it’s partner network, Tavolos helps over 700 restaurants in Asia - a number that is growing fast - to drive customers into restaurants for free, stay ahead of the curve with market data, and increase profits.</p>

        <a class="" href="https://www.tavolos.com/">Find out more about Tavolos</a> or <a class="" href="https://admin.tavolos.com/restaurant/signup">Register my restaurant on Tavolos for free!</a>

      </div>
      </transition>
    </v-layout>
  </v-app>

</template>

<script>

  import axios from 'axios'

  const apiURL = 'https://admin.tavolos.com/api'
  // const apiURL = 'https://stage-admin.tavolos.com/api'

  export default {

    data () {
      return {

        // Default variable
        valid: true,
        toggleEmail: true,
        toggvarimeSlot: true,
        toggleLogo: true,

        // Set default for snackbar message
        snackbar: false,
        snackbarColor: '',
        snackbarMode: '',
        snackbarTimeout: 3000,

        snackbarMessages: '',

        // Tabs index snackbartart at 1 not 0
        tabsIndex: 1,
        reservationID: '',

        // Loader
        loader: null,
        loadingReservation: false,

        menuDate: false,
        menuPeople: false,
        menuTime: false,

        // Covers per booking
        coversPerBookingMin: 1,
        coversPerBookingMax: 10,

        restaurant_status: false,

        // Reservation model
        reservationModel: {
          name: '',
          email: '',
          phoneNumber: '',
          people: '',
          date: null,
          time: null,
          specialRequests: ''
        },

        // Credit card guarantee model
        creditGuaranteeModel: {
          status: false,
          personFee: '',
          personFeeCurrency: '',
          gracePeriodHours: '',
        },

        reservationType: '',

        // Max Covers
        treshold: null,
        maxCoversPerDay: null,
        maxReservationsPerDay: null,
        noLimitedCovers: false,
        dateSeatingBooked: null,

        // Current date value for checkAvailability
        currentSeatingAvailable: null,
        currentDate: null,

        // Validation rules
        emailRules: [
          v => {
            return !!v || 'E-mail is required'
          },
          v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(v) || 'E-mail must be valid'
        ],

        // Get Resource
        getResource: [],
        getAvailability: [],

        availabilityDate: [],
        availabilityDateTime: [],

        tavolos_restaurant_id: '',

        has_publisher: false,
        publisher_logo_src: 'https://widget.tavolos.com/src/assets/publisher/' + this.publisher_id + '.png',
        widgetURL: 'https://book.tavolos.com/restaurant/' + this.restaurant_id,

      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      }
    },
    props: {
      // Set default value
      publisher_id: {
        default: 0,
      },
      restaurant_id: {
        required: true,
        default: 0,
      }
    },
    methods: {

      /**
      * Gets a list of cover options.
      *
      * @return {Number[]}
      */
      getCoverOptions: function () {
        const self = this

        var options = []
        var restaurantMin = self.coversPerBookingMin
        var restaurantMax = self.coversPerBookingMax

        // Ensure values are valid.
        // @todo Move the number somewhere else, maybe to "data"?
        restaurantMin = (restaurantMin >= 1) ? restaurantMin : 1
        restaurantMax = (restaurantMax <= 50) ? restaurantMax : 50

        // Ensure max is alway greater than or equal to min. For example if
        // restaurant sets only min, and the value is higher than the default
        // min value set in widget's config.
        if (restaurantMax < restaurantMin) {
          restaurantMax = restaurantMin
        }

        for (var i = restaurantMin; i <= restaurantMax; i++) {
          options.push(i)
        }

        return options
      },

      getTimeSlot: function (date, people) {

        const self = this
        var timeSlot = []

        // Process only on client browser
        if (process.browser) {
          // If parameter not null
          if ((date != null) && (people.length != 0)) {

            // Loop in availablity object
            $t.each(this.getAvailability, function (index, item) {

              // If choose date = date object
              if (item.date == date) {

                if (item.seatingBooked != null) {
                  self.dateSeatingBooked = item.seatingBooked
                }

                // Loop in object
                $t.each(item.times, function (index, value) {

                  timeSlot.push(value.startTime)

                })
              }
            })
            return timeSlot
          }
        }

  
      },

      goTabs: function (number) {
        this.tabsIndex = number
      },
      editReservation: function () {
        this.tabsIndex = 1

        // Reset creditGuaranteeModel status value
        this.creditGuaranteeModel.status = false

      },

      checkAvailability: function (date, time, people) {

        const self = this

        // Call validation
        this.$refs.formReservation.validate()

        var checkTime = false
        var checkSeatAvailable = false

        if (process.browser) {
          $t.each(self.getAvailability, function (index, item) {
            if (item.date === date) {

              // Check for credit guarantee value
              if (item.guarantee !== undefined) {
                self.creditGuaranteeModel.status = true
                self.creditGuaranteeModel.personFee = item.guarantee.personFee
                self.creditGuaranteeModel.gracePeriodHours = item.guarantee.gracePeriodHours
              }

              // Reset value if credit guarantee false.
              // This is needed especially when user selects a date, and then
              // clicks "Edit reservation" to change the date.
              if (item.guarantee === undefined) {
                self.creditGuaranteeModel.status = false
                self.creditGuaranteeModel.personFee = ''
                self.creditGuaranteeModel.gracePeriodHours = null
              }

              // Prepaid reservation settings.
              if (self.isReservationPrepaid()) {
                // @todo Consider removing this because prepaid and ccg are two different things.
                self.creditGuaranteeModel.status = true
              }

              // Loop for check date, time, people availability
              $t.each(item.times, function (index, value) {

                self.currentSeatingAvailable = value.seatingAvailable
                self.currentDate = date

                if (((value.startTime) === time)) {
                  if (value.seatingAvailable >= 0) {
                    checkTime = true
                  }
                  if (people !== '' && value.seatingAvailable >= people) {
                    checkSeatAvailable = true
                  }
                  if (self.noLimitedCovers == true) {
                    if (people > value.seatingAvailable) {
                      // force reset people
                      self.reservationModel.people = ''
                      self.snackbar = true
                      self.snackbarColor = 'error'
                      self.snackbarMessages = 'There is only ' + value.seatingAvailable + ' available seats on ' + date
                      self.$refs.people.focus()
                    }
                  }
                }

              })
            }
          })

          if (checkSeatAvailable !== true && this.$refs.formReservation.validate()) {
            this.snackbar = true
            this.snackbarColor = 'error'
            this.snackbarMessages = 'There is only ' + self.currentSeatingAvailable + ' available seats on ' + self.currentDate
            this.$refs.people.focus()
          }

          if (checkTime === true && checkSeatAvailable === true && this.$refs.formReservation.validate()) {

            if (this.creditGuaranteeModel.status === true) {

              var redirPath = this.widgetURL + '?mode=ccg&people=' + this.reservationModel.people + '&date=' + this.reservationModel.date + '&time=' + this.reservationModel.time

              window.location.href = redirPath

            } else {

              this.snackbar = true
              this.snackbarColor = 'success'
              this.snackbarMessages = 'Success, please fill your personal detail'

              this.goTabs(2)

            }

          }

        }
      },

      doReservation: function () {

        // Call validation
        if (this.$refs.formReservationInfo.validate()) {

          this.loader = 'loadingReservation'
          // Then call add drupal entity function
          this.addDrupalEntity()

        }
      },

      changeEmail: function () {
        // Then call edit drupal entity function
        this.updateDrupalEntity()
        // Go back to confirm page
        this.goTabs(3)
      },

      addDrupalEntity: function () {

        // Split date / time
        var startDate, startTime

        const self = this

        axios.post(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '/reservations?_format=json', {
          startDate: self.reservationModel.date,
          startTime: self.reservationModel.time,
          people: self.reservationModel.people,
          publisher: self.publisher_id,
          name: self.reservationModel.name,
          email: self.reservationModel.email,
          phone: self.reservationModel.phoneNumber,
          specialRequest: self.reservationModel.specialRequests
        })
          .then(function (response) {
            // console.log(response)

            self.reservationID = response.data.id_reservation

            // Snackbar
            self.snackbar = true
            self.snackbarColor = 'success'
            self.snackbarMessages = 'Thank you for reservation'

            // Then go next page
            self.goTabs(3)

          })
          .catch(function (error) {
            console.log(error)

            // Snackbar
            self.snackbar = true
            self.snackbarColor = 'error'
            self.snackbarMessages = 'Can not do reservation, please contact administrator.'

          })
      },
      updateDrupalEntity: function () {

        const self = this

        // Update drupal entity
        axios.put(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '/reservations/' + self.reservationID + '?_format=json', {
            email: self.reservationModel.email
          })
          .then(function (response) {

            // Snackbar
            self.snackbar = true
            self.snackbarColor = 'success'
            self.snackbarMessages = 'Update reservation'

          })
          .catch(function (error) {
            console.log(error)
          })
      },

      prettyJSON: function (json) {
        if (json) {
          json = JSON.stringify(json, undefined, 4)
          json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>')
          return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, function (match) {
            var cls = 'number'
            if (/^"/.test(match)) { if (/:$/.test(match)) { cls = 'key' } else { cls = 'string' } } else if (/true|false/.test(match)) { cls = 'boolean' } else if (/null/.test(match)) { cls = 'null' }
            return '<span class="' + cls + '">' + match + '</span>'
          })
        }
      },
      randomParameter: function () {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 1; i < 8; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
      },
      isEmpty(value){
        return (value == null || value.length === 0)
      },

      // @todo There are two identical instances of this method. Consider creating eg. a mixin to avoid code repetition.
      isReservationPrepaid() {
        const self = this
        return (self.reservationType === 'prepaid')
      }

    },
    created: function () {

      const self = this
      
      // CASE 1: No publisher_id
      if (this.publisher_id === undefined || this.publisher_id === 0) {

        self.has_publisher = false
        self.tavolos_restaurant_id = self.restaurant_id

        // FETCH Data
        axios.get(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '?_format=json' + '&' + self.randomParameter())
          .then(function (response2) {
            self.getResource = response2.data

            // Check value available by restaurant name
            var checkRestaurantHasName = response2.data.restaurants[0].restaurant

            if (response2.data.restaurants[0].reservationType === "prepaid") {
              self.reservationType = response2.data.restaurants[0].reservationType
            }
            if (response2.data.restaurants[0].coversPerBookingMin) {
              self.coversPerBookingMin = parseInt(response2.data.restaurants[0].coversPerBookingMin)
            }
            if (response2.data.restaurants[0].coversPerBookingMax) {
              self.coversPerBookingMax = parseInt(response2.data.restaurants[0].coversPerBookingMax)
            }
            
            if (checkRestaurantHasName !== undefined && checkRestaurantHasName !== null && checkRestaurantHasName.length > 0) {
              self.restaurant_status = true
            }

          })
          .catch(function (error) {
            console.log(error)
          })

        axios.get(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '/availability?_format=json' + '&' + self.randomParameter())
          .then(function (response3) {
            self.getAvailability = response3.data.availability

            self.treshold = response3.data.treshold
            self.maxCoversPerDay = response3.data.maxCoversPerDay
            self.maxReservationsPerDay = response3.data.maxReservationsPerDay

            if (self.maxCoversPerDay == 0 && self.maxReservationsPerDay == 0) {
              self.noLimitedCovers = true
            }

            if (process.browser) {
              $t.each(self.getAvailability, function (index, item) {

                if (item.times.length != 0){
                  self.availabilityDate.push(item.date)
                }

              })
            }

          })
          .catch(function (error) {
            console.log(error)
          })
      }

      // CASE 2: Have publisher_id then asking for Tavolos NID
      if (this.publisher_id !== undefined || this.publisher_id !== 0) {

        self.has_publisher = true

        axios.get(apiURL + '/publishers/' + self.publisher_id + '/restaurants/' + self.restaurant_id + '?_format=json' + '&' + self.randomParameter())
          .then(function (response1) {

            // If publisher_id do not exist
            if (response1.data.result === 'error') {

              self.has_publisher = false
              self.tavolos_restaurant_id = self.restaurant_id

              // FETCH Data
              axios.get(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '?_format=json' + '&' + self.randomParameter())
                .then(function (response2) {
                  self.getResource = response2.data

                  if (response2.data.restaurants[0].reservationType === "prepaid") {
                    self.reservationType = response2.data.restaurants[0].reservationType
                  }
                  if (response2.data.restaurants[0].coversPerBookingMin) {
                    self.coversPerBookingMin = parseInt(response2.data.restaurants[0].coversPerBookingMin)
                  }
                  if (response2.data.restaurants[0].coversPerBookingMax) {
                    self.coversPerBookingMax = parseInt(response2.data.restaurants[0].coversPerBookingMax)
                  }

                  // Check value available by restaurant name
                  var checkRestaurantHasName = response2.data.restaurants[0].restaurant
                  if (checkRestaurantHasName !== undefined && checkRestaurantHasName !== null && checkRestaurantHasName.length > 0) {
                    self.restaurant_status = true
                  }

                })
                .catch(function (error) {
                  console.log(error)
                })

              axios.get(apiURL + '/restaurants/' + self.tavolos_restaurant_id + '/availability?_format=json' + '&' + self.randomParameter())
                .then(function (response3) {
                  self.getAvailability = response3.data.availability

                  self.treshold = response3.data.treshold
                  self.maxCoversPerDay = response3.data.maxCoversPerDay
                  self.maxReservationsPerDay = response3.data.maxReservationsPerDay

                  if (self.maxCoversPerDay == 0 && self.maxReservationsPerDay == 0) {
                    self.noLimitedCovers = true
                  }

                  if (process.browser) {
                    $t.each(self.getAvailability, function (index, item) {

                      if (item.times.length != 0){
                        self.availabilityDate.push(item.date)
                      }

                    })
                  }

                })
                .catch(function (error) {
                  console.log(error)
                })

            }

            if (response1.data.result === 'success') {

              self.has_publisher = true

              // FETCH data
              self.tavolos_restaurant_id = response1.data.tavolos_restaurant_id

              if (response1.data.restaurants[0].reservationType === "prepaid") {
                self.reservationType = response1.data.restaurants[0].reservationType
              }
              if (response1.data.restaurants[0].coversPerBookingMin) {
                self.coversPerBookingMin = parseInt(response1.data.restaurants[0].coversPerBookingMin)
              }
              if (response1.data.restaurants[0].coversPerBookingMax) {
                self.coversPerBookingMax = parseInt(response1.data.restaurants[0].coversPerBookingMax)
              }

              axios.get(apiURL + '/restaurants/' + response1.data.tavolos_restaurant_id + '?_format=json' + '&' + self.randomParameter())
                .then(function (response2) {
                  self.getResource = response2.data

                  // Check value available by restaurant name
                  var checkRestaurantHasName = response2.data.restaurants[0].restaurant
                  if (checkRestaurantHasName !== undefined && checkRestaurantHasName !== null && checkRestaurantHasName.length > 0) {
                    self.restaurant_status = true
                  }

                })
                .catch(function (error) {
                  console.log(error)
                })

              axios.get(apiURL + '/restaurants/' + response1.data.tavolos_restaurant_id + '/availability?_format=json' + '&' + self.randomParameter())
                .then(function (response3) {
                  self.getAvailability = response3.data.availability
                  
                  self.treshold = response3.data.treshold
                  self.maxCoversPerDay = response3.data.maxCoversPerDay
                  self.maxReservationsPerDay = response3.data.maxReservationsPerDay

                  if (self.maxCoversPerDay == 0 && self.maxReservationsPerDay == 0) {
                    self.noLimitedCovers = true
                  }

                  if (process.browser) {
                    $t.each(self.getAvailability, function (index, item) {

                      if (item.times.length != 0){
                        self.availabilityDate.push(item.date)
                      }

                    })
                  }

                })
                .catch(function (error) {
                  console.log(error)
                })
            }

          })
          .catch(function (error) {
            console.log(error)
          })
      }

    },
  }
</script>

<style lang="scss">

#tavolos-widget {
  position: relative;
  // Add static v-menu pops
  .menu__content {
    min-width: 290px !important;
    max-width: 400px !important;
    overflow: auto;
    &.tavolos-block-people {
      top: 92px!important;
      left: 40px!important;
    }
    &.tavolos-block-date {
      top: 168px!important;
      left: 40px!important;
    }
    &.tavolos-block-time {
      top: 248px!important;
      left: 40px!important;
    }
  }

}

#ccg-warning {
  padding: 10px 15px;
  line-height: 1;
  background: lemonchiffon;
  background: #fffacd;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 20px;
  i {
    vertical-align: middle;
    margin-right: 6px;
  }
}
#ccg-notice {
  margin: 15px 0;
  p:last-child {
    margin-bottom: 0;
  }
}

@media (min-width: 600px) {
  #tavolos-widget {
    .menu__content {
      &.tavolos-block-people {
        top: 92px!important;
        left: 40px!important;
      }
      &.tavolos-block-date {
        top: 92px!important;
        left: calc(50% + 50px)!important;
      }
      &.tavolos-block-time {
        top: 168px!important;
        left: 40px!important;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Book.vue